import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import ReferralProgramPage from '../views/ReferralProgramPage.vue'
import ReferralLandingPage from '../views/ReferralLandingPage.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/referral-program',
    name: 'ReferralProgram',
    component: ReferralProgramPage
  },
  {
    path: '/ref/:code',
    name: 'ReferralLanding',
    component: ReferralLandingPage
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router

